export enum SearchOption {
  BUSINESS_NAME = "business_legal_name",
  CONTACT_NAME = "contact_name",
  BUSINESS_PHONE = "business_telephone",
  BIN = "bin",
  BUSINESS_ADDRESS = "business_address",
}
